import { render, staticRenderFns } from "./BuyerRoiTT.vue?vue&type=template&id=f9485790&"
import script from "./BuyerRoiTT.vue?vue&type=script&lang=js&"
export * from "./BuyerRoiTT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports